import { Controller } from '@hotwired/stimulus'
import fetchWithHandlingLoginRedirect from '../../modules/utils/fetchWithHandlingLoginRedirect'
import $ from 'jquery'
import { trans, UNTIL_BREACH_WITH_STATUS_NAME_LABEL, BREACHED_WITH_STATUS_NAME_LABEL } from '../../translator'

const IssueEventType = {
  slo_threshold_status_updated: 'issue.slo.threshold_status_updated'
}

export default class extends Controller {
  static values = {
    sloMessageSectionUrl: String
  }

  static targets = [
    'sloMessageSection'
  ]

  timerIntervalId = null

  disconnect () {
    super.disconnect()
    document.removeEventListener('MercureEvent', this.handleMercureEvent)
    document.removeEventListener('CategoriesUpdatedEvent', this.releadSloMessageSection)
    document.removeEventListener('StatusUpdatedEvent', this.releadSloMessageSection)
  }

  connect () {
    this.handleMercureEvent = this.handleMercureEvent.bind(this)
    this.releadSloMessageSection = this.releadSloMessageSection.bind(this)

    document.addEventListener('MercureEvent', this.handleMercureEvent)
    document.addEventListener('CategoriesUpdatedEvent', this.releadSloMessageSection)
    document.addEventListener('StatusUpdatedEvent', this.releadSloMessageSection)
    this.startTimerLoop()
  }

  handleMercureEvent (mercureEvent) {
    const { event } = mercureEvent.detail.data

    if (event === IssueEventType.slo_threshold_status_updated) {
      this.releadSloMessageSection()
      const historyUpdatedEvent = new CustomEvent('HistoryUpdatedEvent')
      document.dispatchEvent(historyUpdatedEvent)
    }
  }

  releadSloMessageSection () {
    fetchWithHandlingLoginRedirect(this.sloMessageSectionUrlValue, {})
      .then((response) => {
        if (!response.ok) {
          return Promise.reject(response)
        }
        return response.json()
      })
      .then((data) => {
        this.sloMessageSectionTarget.innerHTML = data.slo_message_section
        this.startTimerLoop()
      })
      .catch(() => {
        // eslint-disable-next-line no-console
        console.error('Error fetching sloMessageSection')
      })
  }

  startTimerLoop () {
    if (this.timerIntervalId) {
      clearInterval(this.timerIntervalId)
    }
    this.updateTimers() // first render
    this.timerIntervalId = setInterval(this.updateTimers, 1000)
  }

  updateTimers () {
    const nowTimestamp = Math.floor(Date.now() / 1000)

    $('.countdown-timer').not('.breached').each(function () {
      const $el = $(this)
      const deadlineTimestamp = parseInt($el.data('deadline'), 10)
      const breachingRecordStatusName = $el.data('breaching-record-status-name')
      if (isNaN(deadlineTimestamp)) return

      const diffSec = deadlineTimestamp - nowTimestamp

      if (diffSec <= 0) {
        $el
          .closest('[class*="raven-bg-"]')
          .removeClass(function (i, className) {
            return (className.match(/(^|\s)raven-bg-\S+/g) || []).join(' ')
          })
          .addClass('raven-bg-danger animate-breached')

        $el.text(trans(BREACHED_WITH_STATUS_NAME_LABEL, {'%breaching_record_status_name%': breachingRecordStatusName}, 'service-level-objectives'))
        $el.addClass('breached')
        return
      }

      const minutes = Math.floor(diffSec / 60)
      const seconds = diffSec % 60

      const countdownTime = `<strong>${minutes}:${seconds.toString().padStart(2, '0')}</strong>`
      $el.html(trans(UNTIL_BREACH_WITH_STATUS_NAME_LABEL, { '%countdown_time%': countdownTime, '%breaching_record_status_name%': breachingRecordStatusName }, 'service-level-objectives'))
    })
  }
}
